function isMobile (){
    let mql = window.matchMedia('(max-width: 1023px)');
    return mql.matches;
}

export {isMobile}